import { atom } from 'jotai';
export const productImagesAtom = atom(new Map());
